import { updateMainById } from '../api';

const updateMain = (
  id,
  image,
) => {
  const formData = new FormData();
  formData.append('image', image);
  return updateMainById(
    id,
    formData,
  );
};

export default updateMain;
